import setupLight from "../../../../contents/images/tutorials/toolbar/setup-toolbar-light-mode.mp4";
import setupDark from "../../../../contents/images/tutorials/toolbar/setup-toolbar-dark-mode.mp4";
import * as React from 'react';
export default {
  setupLight,
  setupDark,
  React
};